import { render } from "./NewHomePlans.vue?vue&type=template&id=3b741f06"
import script from "./NewHomePlans.vue?vue&type=script&lang=js"
export * from "./NewHomePlans.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__